export default "__VITE_ASSET__5wqWYmOn__"